import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import indusbgimg from "../../bg_images/I_sec1_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const Servicecards = [
  {
    title: " Infrastructure Limitations Hinder Efficiency",
    text: " Our automated healthcare IT solutions help upgrade your systems with scalable and reliable technology, ensuring smooth operations.",
  },
  {
    title: "Financial Constraints Slow Innovationy",
    text: "Arshil provides cost-effective healthcare IT consulting to help organizations adopt cutting-edge solutions within budget, maximizing impact.",
  },
  {
    title: "Data Security and Privacy Risks",
    text: "Arshil’s healthcare IT security solutions offer enterprise-grade protection to secure sensitive information and maintain confidentiality.",
  },
  {
    title: "Lack of Interoperability Stalls Progress",
    text: "Our healthcare IT solution services enhance interoperability, improving data exchange and optimizing clinical workflows.",
  },
  {
    title: "Resistance to Technology Adoption",
    text: "We offer next-gen healthcare IT solutions that are user-friendly and provide necessary training to ensure smooth integration into your workflows.",
  },
];

const Healthcare = () => {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleServicecards, setVisibleServicecards] = useState(3);

  
  useEffect(() => {
    const updateVisibleServicecards = () => {
      if (window.innerWidth <= 768) {
        setVisibleServicecards(1); 
      } else {
        setVisibleServicecards(3); 
      }
    };

    updateVisibleServicecards();
    window.addEventListener("resize", updateVisibleServicecards);
    return () =>
      window.removeEventListener("resize", updateVisibleServicecards);
  }, []);

  const handleNext = () => {
    if (currentIndex + visibleServicecards < Servicecards.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="Industries">
      <div className="I_sec1" style={{ backgroundImage: `url(${indusbgimg})` }}>
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Healthcare
        </h5>
        <h1>Transforming Healthcare with Reliable IT Solutions</h1>
        <p>
          Arshil delivers next-gen healthcare IT solutions that improve
          operations, enhance patient care, and address critical industry
          challenges.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          See Our Services
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>What We Offer for Healthcare Providers</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_sec2_icon3.svg"
                alt=""
              />
              Automated Healthcare IT Solutions
            </h6>
            <p>
              Streamline healthcare operations with automated IT systems that
              reduce manual tasks, improve efficiency, and enhance service
              delivery.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_sec2_icon1.svg"
                alt=""
              />
              Healthcare IT Security Services
            </h6>
            <p>
              Protect sensitive patient data and ensure compliance with industry
              standards using advanced cybersecurity measures tailored for
              healthcare organizations.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_sec2_icon2.svg"
                alt=""
              />
              Government Healthcare IT Solutions
            </h6>
            <p>
              Build scalable, compliant IT systems that meet the needs of public
              healthcare institutions, ensuring seamless operation and patient
              care.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_sec2_icon4.svg"
                alt=""
              />
              Outsourced Healthcare IT Support
            </h6>
            <p>
              Minimize downtime and ensure smooth operations with reliable IT
              support services that keep healthcare systems running without
              interruption.
            </p>
          </section>
        </section>

        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}

      <div className="S_carousel-container">
        <h2 className="S_carousel-title">
          Solving the Key Challenges in Healthcare IT
        </h2>
        <div className="S_carousel-wrapper">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel">
            <div
              className="S_carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <div className="S_carousel-card" key={index}>
                  <h3>{card.title}</h3>
                  <div className="underline"></div>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>
            How Arshil Transformed Operations For A Healthcare Client And
            Improved Productivity
          </h6>
          <p>
            Our client wanted to create a platform that would connect
            researchers, medical professionals, and patients in India, providing
            a seamless experience for clinical trial participation. Our team
            developed and deployed a robust web application using advanced cloud
            technologies.
          </p>
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_sec4_img1.png"
            alt="I_sec4_img1"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>
            Ready to Transform Your Organization with Innovative Healthcare IT?
          </h4>
          <p>
            Partner with Arshil for reliable healthcare IT solutions that
            improve patient care, enhance security, and streamline operations.
            Let us solve your biggest challenges together.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Speak to Our Team Today{" "}
            <HiArrowNarrowRight className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Healthcare;
